import React, { Component } from 'react';
import ReactTable from 'react-table';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as UsersActions from './redux/UsersActions';

import auth from '../../libCustom/auth';

class UserIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      valor: '',
    };
  }

  async componentWillMount() {
    let params = {};
    if (auth.can('admin')) {
      params = {
        include: ['franchise'],
        where: {
          franchiseId: auth.getCurrentUser().franchiseId,
        },
      };
    } else {
      params = {
        include: ['franchise'],
      };
    }

    this.props.find(params);
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  getTrProps = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          background:
            rowInfo && rowInfo.original && rowInfo.original.validated === true
              ? 'white'
              : '#fcefe2',
        },
      };
    }
    return {};
  };

  render() {
    let _this = this;
    let { history, Users } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Usuarios'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() => history.push('/admin/users/create')}
                      >
                        Agregar Usuario
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Users.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    //getTrProps={this.getTrProps}
                    data={Users.searchData ? Users.searchData : Users.data}
                    page={Users.table.page}
                    sorted={Users.table.sorted}
                    filtered={Users.table.filtered}
                    pageSize={Users.table.pageSize}
                    onSortedChange={(change) =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={(change) =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={(change) =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={(change) =>
                      _this.props.changeTable('pageSize', change)
                    }
                    previousText={'Anterior'}
                    nextText={'Siguiente'}
                    loadingText={'Cargando...'}
                    noDataText={'No se encontraron registros'}
                    pageText={'Página'}
                    ofText={'de'}
                    rowsText={'filas'}
                    columns={[
                      {
                        Header: 'Nombre',
                        accessor: 'firstName',
                      },
                      {
                        Header: 'Apellidos',
                        accessor: 'lastName',
                      },
                      {
                        Header: 'Email',
                        accessor: 'email',
                        minWidth: 120,
                      },
                      {
                        Header: 'Franquicia',
                        accessor: 'franchise.name',
                        minWidth: 120,
                      },
                      {
                        Header: 'Acciones',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: (props) => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/users/' + props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>{' '}
                          </div>
                        ),
                      },
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Users: state.Users,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(UsersActions, dispatch);
};

const UsersConnect = connect(mapStateToProps, mapDispatchToProps)(UserIndex);

export default UsersConnect;



// WEBPACK FOOTER //
// ./src/views/Users/UsersIndex.jsx